module.exports = __webpack_public_path__ + "media/images/checked_radio-033a7d34906fb1940907c30aa80c7bde.svg";